import { z } from "zod";

import { gql } from "@/generated/gql";
import { Respondent, RespondentTypeEnum } from "@/generated/gql/graphql";
import { BaseRespondent } from "@/session";

export const PlaceholderRespondentForProfessional: BaseRespondent = {
  id: "epd-frontend-placeholder-for-null-respondent-on-pending-responses",
  label: null,
  type: RespondentTypeEnum.Profess,
  loginToken: null,
  isEditable: false,
  isEmailEditable: false,
  pronounOverrides: {
    __typename: "PronounSet",
    subject: null,
    object: null,
    possessiveDeterminer: null,
    honorific: null,
    honorificWithArticle: null,
  },
};

export const CreateRespondentMutation = gql(/* GraphQL */ `
  mutation createRespondent($input: RespondentCreateInput!) {
    mutation: respondentCreate(input: $input) {
      result {
        respondent {
          ...Respondent
        }
      }

      errors {
        message
        path
      }
    }
  }
`);

export function patientRespondentName(respondent: Pick<Respondent, "firstname" | "lastname">) {
  if (respondent.firstname || respondent.lastname) {
    return [respondent.firstname, respondent.lastname].join(" ");
  } else {
    return null;
  }
}

export function respondentNameOrLabel(
  respondent: Pick<Respondent, "type" | "firstname" | "lastname" | "label">,
) {
  if (respondent.type === RespondentTypeEnum.Patient) {
    return patientRespondentName(respondent);
  } else {
    return respondent.label;
  }
}

const respondentTypesInOrder = [
  RespondentTypeEnum.Patient,
  RespondentTypeEnum.Parent,
  RespondentTypeEnum.SecondParent,
  RespondentTypeEnum.Caregiver,
  RespondentTypeEnum.Teacher,
  RespondentTypeEnum.Profess,
  RespondentTypeEnum.AdHocProfessional,
] as const;

export const zodRespondentTypeEnum = z.enum(respondentTypesInOrder);

export const respondentTypeIndex = (respondentType: RespondentTypeEnum) => {
  return respondentTypesInOrder.indexOf(respondentType);
};

export function respondentTypeWithSuffix(type: RespondentTypeEnum) {
  if (type === RespondentTypeEnum.AdHocProfessional) {
    return type;
  } else {
    return `${type}_version`;
  }
}

export function loginTokenWithSpaces(loginToken: string | null | undefined) {
  if (!loginToken) {
    return loginToken;
  }

  if (loginToken.length % 3 === 0) {
    return loginToken.match(/.{1,3}/g)?.join(" ") ?? "";
  } else if (loginToken.length % 4 === 0) {
    return loginToken.match(/.{1,4}/g)?.join(" ") ?? "";
  } else {
    return loginToken;
  }
}
